/**
 *
 *  Rate Session
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 05/07/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import { useAppState } from "../../state";

// Components
import Button from "../Button/Button";

// Icons
import ArrowRightIcon from "../../icons/ArrowRightIcon";
import CheckNiceIcon from "../../icons/CheckNiceIcon";

// Images
import StarFull from "./StarFull";
import StarEmpty from "./StarEmpty";
import Lotus from "./Lotus";

const Star = ({ selected, index, onMouseEnter, onMouseLeave, onClick }) => {
  // eslint-disable-next-line no-unused-vars
  const [hovered, setHovered] = useState();

  const handleEnter = React.useCallback(() => {
    setHovered(true);
    onMouseEnter(index);
  }, [index, onMouseEnter]);

  // const handleLeave = React.useCallback(() => {
  //   setHovered(false);
  //   onMouseLeave(index);
  // }, [index, onMouseLeave]);

  const handleClick = React.useCallback(() => {
    onClick(index);
  }, [index, onClick]);

  return (
    <div
      onMouseEnter={handleEnter}
      // onMouseLeave={handleLeave}
      onClick={handleClick}
    >
      {/*hovered || */ selected ? <StarFull /> : <StarEmpty />}
    </div>
  );
};

export const RateSession = ({
  partnerId,
  partnerFullName,
  partnerProfilePictureUrl,
  bookingId,
  bookingDateTimeLabel,
  // onReviewSubmitted,
  onClose,
}) => {
  const history = useHistory();

  const { user, sendReview } = useAppState();

  const [_bookingId, setBookingId] = useState(bookingId);
  const [modalTitle, setModalTitle] = useState("Help Us Help You.");
  const [selected, setSelected] = useState([]);
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");

  const [hasRatingBeenSet, setHasRatingBeenSet] = useState(false);
  const [hasBeenSubmitted, setHasBeenSubmitted] = useState(false);

  useEffect(() => {
    if (bookingId) {
      setBookingId(bookingId);
    }
  }, [bookingId]);

  const handleStarMouseEnter = (index) => {
    let arr = [];

    for (let i = 0; i < 5; i++) {
      if (i < index) {
        arr.push(true);
      } else {
        arr.push(false);
      }
    }

    setSelected(arr);
  };

  const handleStarMouseLeave = (index) => {
    let arr = [];

    for (let i = 0; i < 5; i++) {
      if (i < index) {
        arr.push(true);
      } else {
        arr.push(false);
      }
    }

    setSelected(arr);
  };

  const handleStarWrapperMouseLeave = () => {
    let arr = [];

    for (let i = 0; i < 5; i++) {
      if (i < rating) {
        arr.push(true);
      } else {
        arr.push(false);
      }
    }

    setSelected(arr);
  };

  const handleStarClick = (index) => {
    let arr = [];
    let rating = 0;

    for (let i = 0; i < 5; i++) {
      if (i < index) {
        arr.push(true);
        rating++;
      } else {
        arr.push(false);
      }
    }

    setRating(rating);
    setSelected(arr);
  };

  const handleReviewChange = (e) => {
    const value = e.target.value;

    setReview(value);
  };

  const handleSubmit = () => {
    if (!hasRatingBeenSet) {
      setHasRatingBeenSet(true);
      setModalTitle("More to Share?");
    }

    if (hasRatingBeenSet && !hasBeenSubmitted) {
      sendReview(user.id, rating, review, partnerId, bookingId).then(() => {
        setModalTitle("Thanks.");
        setHasBeenSubmitted(true);

        // onReviewSubmitted();
      });
    } else if (hasBeenSubmitted) {
      history.push(`/account/bookings/${_bookingId}/repeat`);
      onClose();
    }
  };

  return (
    <div>
      {/*<button*/}
      {/*  onClick={closeModal}*/}
      {/*  className="tbk-absolute tbk-top-2 tbk-right-2 tbk-z-10 tbk-text-coral"*/}
      {/*>*/}
      {/*  <CloseIcon />*/}
      {/*</button>*/}
      <div className="tbk-relative tbk-mb-3 tbk-rounded-lg tbk-bg-basic-white tbk-p-3 md:tbk-p-0">
        <h2
          className={`tbk-text-title-bold tbk-t-0 ${
            hasBeenSubmitted ? "tbk-mb-2" : "tbk-mb-1"
          } tbk-text-center tbk-text-primary`}
        >
          {modalTitle}
        </h2>
        {hasBeenSubmitted ? <Lotus className="tbk-mx-auto tbk-mb-2" /> : null}
        <p
          className={`tbk-text-main ${
            hasRatingBeenSet ? "tbk-mb-1" : "tbk-mb-4"
          } tbk-text-center tbk-text-primary`}
        >
          {hasRatingBeenSet ? (
            hasBeenSubmitted ? (
              "We can’t wait to see you again."
            ) : (
              <div>
                Write a short review about your session.
                <br />
                We really appreciate your feedback.
              </div>
            )
          ) : (
            `Please rate your session with ${partnerFullName} on ${bookingDateTimeLabel}.`
          )}
        </p>

        {hasRatingBeenSet && !hasBeenSubmitted ? (
          <>
            <div className="tbk-text-small tbk-mb-0.5 tbk-text-primary">
              Your review:
            </div>
            <textarea
              className="tbk-text-main tbk-botder-solid tbk-mb-4 tbk-w-full tbk-rounded-lg tbk-border tbk-border-blue-grey-light tbk-py-1.5 tbk-px-2 tbk-text-primary"
              name="review"
              id=""
              cols="30"
              rows="5"
              placeholder="Pros and cons, any thoughts"
              maxLength={256}
              value={review}
              onChange={handleReviewChange}
            />
          </>
        ) : (
          !hasBeenSubmitted && (
            <div className="tbk-mb-8 tbk-flex tbk-flex-col tbk-items-center lg:tbk-mb-4 ">
              <img
                className="tbk-mx-auto tbk-mb-4 tbk-h-8 tbk-w-8 tbk-shrink-0 tbk-overflow-hidden tbk-rounded-full tbk-object-cover"
                itemProp="image"
                src={partnerProfilePictureUrl}
                // alt={`${bundle.partnerFullName} photo`}
              />

              <div
                className="tbk-flex tbk-w-full tbk-justify-evenly"
                onMouseLeave={handleStarWrapperMouseLeave}
              >
                <Star
                  index={1}
                  selected={selected[0]}
                  onMouseEnter={handleStarMouseEnter}
                  onMouseLeave={handleStarMouseLeave}
                  onClick={handleStarClick}
                />
                <Star
                  index={2}
                  selected={selected[1]}
                  onMouseEnter={handleStarMouseEnter}
                  onMouseLeave={handleStarMouseLeave}
                  onClick={handleStarClick}
                />
                <Star
                  index={3}
                  selected={selected[2]}
                  onMouseEnter={handleStarMouseEnter}
                  onMouseLeave={handleStarMouseLeave}
                  onClick={handleStarClick}
                />
                <Star
                  index={4}
                  selected={selected[3]}
                  onMouseEnter={handleStarMouseEnter}
                  onMouseLeave={handleStarMouseLeave}
                  onClick={handleStarClick}
                />
                <Star
                  index={5}
                  selected={selected[4]}
                  onMouseEnter={handleStarMouseEnter}
                  onMouseLeave={handleStarMouseLeave}
                  onClick={handleStarClick}
                />
              </div>
            </div>
          )
        )}

        <Button
          className="tb-button tbk-mt-4 tbk-w-full"
          disabled={!rating}
          endIcon={hasRatingBeenSet ? CheckNiceIcon : ArrowRightIcon}
          onClick={handleSubmit}
        >
          {hasBeenSubmitted
            ? "Book Again"
            : hasRatingBeenSet
            ? "Done"
            : "Submit"}
        </Button>
        {hasBeenSubmitted && (
          <div className="tbk-text-center">
            <button
              className="tbk-text-main tbk-mt-2 tbk-text-grey tbk-underline hover:tbk-text-grey-inactive"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

RateSession.displayName = "Reviews";

RateSession.propTypes = {
  partnerId: PropTypes.number.isRequired,
  partnerFullName: PropTypes.string.isRequired,
  partnerProfilePictureUrl: PropTypes.string.isRequired,
  bookingId: PropTypes.string.isRequired,
  bookingDateTimeLabel: PropTypes.string.isRequired,
  // onReviewSubmitted: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RateSession;
